import { combineReducers } from 'redux';

import { reducer as accountReducer, type AccountState } from './accounts';
import { reducer as authReducer, type AuthState } from './auth';
import { reducer as provisioningReducer, type ProvisioningState } from './provisioning/reducer';
import { reducer as settingsReducer, type SettingsState } from './settings';

export type AppState = Readonly<{
  auth: AuthState;
  settings: SettingsState;
  accounts: AccountState;
  provisioning: ProvisioningState;
}>;

export default combineReducers({
  auth: authReducer,
  settings: settingsReducer,
  accounts: accountReducer,
  provisioning: provisioningReducer,
});
